import { HttpParams } from '@angular/common/http';
import { forwardRef, Inject, Injectable } from '@angular/core';
import * as moment_tz from 'moment-timezone';
import { firstValueFrom } from 'rxjs';
import { LOCATION_PARTNER_AUTHORIZATION_BY_ID, LOCATION_PARTNER_AUTHORIZATIONS, LOCATION_PARTNER_AUTHORIZATIONS_BY_LOCATION_ID, USER_PARTNERS } from '../../../common/endpoints';
import { Location, LocationPartnerAuthorization, Partner } from '../../../model';
import { HttpService } from '../../../service/http.service';
import { TreeService } from '../../../service/tree.service';

@Injectable()
export class LocationAuthorizationService {

    constructor(
        @Inject(forwardRef(() => HttpService)) private httpService: HttpService,
        @Inject(forwardRef(() => TreeService)) private treeService: TreeService,
    ) { }

    getLocationPartnerAuthorizations(locationId: string): Promise<LocationPartnerAuthorization[]> {
        const endpoint = LOCATION_PARTNER_AUTHORIZATIONS_BY_LOCATION_ID.replace('{id}', locationId);
        return this.get(endpoint);
    }

    getLocationPartnerAuthorizationsByCustomerId(customerId: string): Promise<LocationPartnerAuthorization[]> {
        return firstValueFrom(this.httpService.get<LocationPartnerAuthorization[]>(LOCATION_PARTNER_AUTHORIZATIONS, new HttpParams().set('customerId', customerId)));
    }

    getPartners(): Promise<Partner[]> {
        return this.get(USER_PARTNERS);
    }

    saveLocationPartnerAuthorization(body: any, id?: string): Promise<LocationPartnerAuthorization> {
        if (id) {
            return firstValueFrom(this.httpService.put(LOCATION_PARTNER_AUTHORIZATION_BY_ID.replace('{id}', id), body));
        } else {
            return firstValueFrom(this.httpService.post(LOCATION_PARTNER_AUTHORIZATIONS, body));
        }
    }

    saveLocationPartnerAuthorizationWithPartnerCode(location: Location, partnerCode: string, endTimestamp: number): Promise<any> {
        const body = this.createBody(location, endTimestamp);
        let params = new HttpParams();
        params = params.set('partnerCode', partnerCode);
        return firstValueFrom(this.httpService.post(LOCATION_PARTNER_AUTHORIZATIONS, body, params, this.getContext(location)));
    }

    deleteLocationPartnerAuthorization(authorization: LocationPartnerAuthorization): Promise<void> {
        return firstValueFrom(this.httpService.delete(LOCATION_PARTNER_AUTHORIZATION_BY_ID.replace('{id}', authorization.id)));
    }

    private get(endpoint: string): Promise<any> {
        return firstValueFrom(this.httpService.get<any>(endpoint))
            .catch(err => {
                console.error(err);
                return [];
            });
    }

    private getContext(node: any): string {
        return this.treeService.getContextFromNode(this.treeService.getContextFromLocation(node), 'Authorizations');
    }


    private createBody(location: { id: string }, endTimestamp: number): any {
        return {
            location: { id: location.id },
            endTimestamp: moment_tz.tz(endTimestamp, 'UTC').valueOf()
        }
    }
}